export default __webpack_public_path__ + "static/media/SWT1370.34I-35001_-24511_0.5002e13d.jpg";